module.exports = __webpack_public_path__ + "static/Testeira_MaxiPack_7-ead3dff5403275e3ec60a10e262a5373.jpg";